module.exports = __webpack_public_path__ + "img/play_peanut.cbf89073.svg";